( ( $ ) => {

	$( '[data-hero-slider]' ).each( function initSlider( index, el ) {
			initSlick( $( el ) );
	} );

	function initSlick( $el ) {
		const $slick = $( '[data-slides-wrapper]', $el );
		const $dots = $( '[data-dots-wrapper]', $el );


		$slick.slick( {
			autoplay: true,
			autoplaySpeed: 7000,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			fade: true,
			appendDots: $dots
		} );
	}

} )( jQuery )